/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
var CustomFilter = (function () {
    function CustomFilter() {
    }
    return CustomFilter;
}());
export { CustomFilter };
//# sourceMappingURL=custom-filter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/providers/custom-filter.js
// module id = 87
// module chunks = 4